import { DefaultOptions, QueryClient } from '@tanstack/react-query';

const queryConfig: DefaultOptions = {
  queries: {
    refetchOnWindowFocus: false,
    // Don't retry failed requests — prevents console spam when offline
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    retry: (failureCount, error: any) => {
      if (!navigator.onLine) {
        return false;
      } // no retries when offline
      if (error?.response?.status >= 400 && error?.response?.status < 500) {
        return false;
      } // no retries on 4xx
      return failureCount < 2;
    }
  }
};

export const queryClient = new QueryClient({ defaultOptions: queryConfig });
